import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "contact-conversation" }
const _hoisted_2 = { class: "contact-conversation__platform" }
const _hoisted_3 = { class: "contact-conversation__details" }
const _hoisted_4 = { class: "contact-conversation__title" }
const _hoisted_5 = { class: "contact-conversation__date" }
const _hoisted_6 = { class: "contact-conversation__header-right" }
const _hoisted_7 = {
  key: 0,
  class: "contact-conversation__message-container"
}

import moment from 'moment';
import { Conversation } from '../models/conversation';
import { conversationApi } from '../services/conversationApi';
import LoadingSpinner from '@/shared/components/loadingSpinner/LoadingSpinner.vue';
import { ConversationMessage } from '../models/conversation-message';
import ChannelIcon from '@/shared/icons/ChannelIcon.vue';
import { computed, onMounted, PropType, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactConversation',
  props: {
  conversation: {
    type: Object as PropType<Conversation>,
    required: true,
  },
  workspaceId: {
    type: String,
    required: true,
  },
  expanded: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;

const maxConversationTitleLength = ref(50);
const messages = ref<any[]>([]);
const loading = ref(false);
const messageTrayOpen = ref(false);
const hasLoadedMessages = ref(false);

onMounted(() => {
  if (props.expanded) {
    toggleMessageTray();
  }
});

const truncatedTitle = computed(() => {
  if (!props.conversation.title) {
    return `Conversation on ${channelIdentityName.value}`;
  }
  return props.conversation.title.length > maxConversationTitleLength.value
    ? props.conversation.title.substring(0, maxConversationTitleLength.value) + '...'
    : props.conversation.title;
});

const conversationDate = computed(() => {
  const date = new Date(props.conversation.createdTimeUtc);
  return moment(date).format('dddd Do MMMM');
});

const channelType = computed(() => {
  return props.conversation.channelIdentity.type;
});

const channelIdentityName = computed(() => {
  switch (channelType.value) {
    case 'sms-bt':
      return 'BT Smart Messaging Tailored';
    case 'sms-govuknotify':
      return 'GOV.UK Notify SMS';
    case 'messenger':
      return 'Facebook Messenger';
    case 'instagram':
      return 'Instagram';
    case 'whatsapp':
      return 'WhatsApp';
    default:
      return 'Web Assistant';
  }
});

async function getMessages() {
  loading.value = true;
  const response = await conversationApi.getConversationMessages(props.workspaceId, props.conversation.id);
  messages.value = response.messages?.map((message) => ({
    type: getMessageType(message),
    text: getMessageText(message),
    direction: message.role === 'appUser' ? 'inbound' : 'outbound',
    status: message.status,
    timestampUtc: message.received,
    actions: message.actions ? message.actions.map((action) => action.payload) : [],
    name: !message.name ? 'Unknown' : message.name,
    avatarUrl: message.avatarUrl,
    card: getMessageCard(message),
    mediaSrc: message.mediaUrl,
    fileName: message.mediaFilename,
    fileSize: message.mediaSize,
    fileType: message.mediaType,
  }));
  loading.value = false;
}

function getMessageType(m: ConversationMessage): string {
  if (m.role === 'whisper') {
    return 'whisper';
  }
  return m.type;
}

function getMessageText(m: ConversationMessage): string {
  if (m.role === 'whisper' && m.text) {
    return m.text;
  }

  if (m.role === 'whisper' && m.metadata) {
    return m.metadata.description;
  }

  if (m.type === 'text') {
    return m.text;
  }

  return '';
}

function getMessageCard(m: ConversationMessage): any {
  if (m.type === 'app' && m.app) {
    return { content: m.app.card };
  }
  return null;
}

function toggleMessageTray() {
  if (shouldLoadMessages()) {
    getMessages();
  }
  messageTrayOpen.value = !messageTrayOpen.value;
}

function shouldLoadMessages(): boolean {
  if (messageTrayOpen.value) {
    return false;
  }
  return !hasLoadedMessages.value || props.conversation.status === 'open';
}

function onLoad($state: any) {
  // Mark state as complete to hide the loader.on the conversation thread
  $state.complete();
}

return (_ctx: any,_cache: any) => {
  const _component_n_loading_spinner = _resolveComponent("n-loading-spinner")!
  const _component_n_conversation_thread = _resolveComponent("n-conversation-thread")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "contact-conversation__expand-trigger",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleMessageTray()))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["contact-conversation__trigger-content", { 'contact-conversation__trigger-content--expanded': messageTrayOpen.value }])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(ChannelIcon, { channelType: channelType.value }, null, 8, ["channelType"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, _toDisplayString(truncatedTitle.value), 1),
          _createElementVNode("span", _hoisted_5, _toDisplayString(conversationDate.value), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: _normalizeClass(["contact-conversation__expanded-indicator", { 'contact-conversation__expanded-indicator--expanded': messageTrayOpen.value }])
          }, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("svg", { class: "right-arrow" }, [
              _createElementVNode("use", {
                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                "xlink:href": "#arrow-right2"
              })
            ], -1)
          ]))], 2)
        ])
      ], 2)
    ]),
    (messageTrayOpen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (loading.value)
            ? (_openBlock(), _createBlock(_component_n_loading_spinner, { key: 0 }))
            : _createCommentVNode("", true),
          (!loading.value)
            ? (_openBlock(), _createBlock(_component_n_conversation_thread, {
                key: 1,
                messages: messages.value,
                onLoad: onLoad,
                displayAvatar: true,
                enableAvatarTooltip: true
              }, null, 8, ["messages"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})